import { connect } from 'react-redux'
import { withProps, withPropsOnChange, mapProps, compose, withHandlers } from 'recompose'
import { reduxForm } from 'redux-form'
import { inputTypes } from 'components/common/FormElements/Input'
import { convertSortToOptions } from 'helpers/options'
import { getSearchQuery } from '../../selectors'
import { applySort } from './actions'
import { FORM_NAME, SORT_BY_INPUT_NAME, SORT_BY_INPUT_LABEL } from './constants'
import ResultsPageListHeader from './ResultsPageListHeader'

const mapStateToProps = (state) => ({
  searchQuery: getSearchQuery(state)
})

const mapSortOptions = mapProps(({ sortOptions, ...props }) => ({
  ...props,
  options: convertSortToOptions(sortOptions)
}))

export default compose(
  connect(mapStateToProps, { applySort }),
  mapSortOptions,
  withPropsOnChange(
    ({ searchQuery: currentSearchQuery, totalNumRecs: currentTotalNumRecs }, { searchQuery, totalNumRecs }) =>
      !!searchQuery && (currentSearchQuery !== searchQuery || currentTotalNumRecs !== totalNumRecs),
    ({ searchQuery, totalNumRecs }) => ({
      searchSummary: `Found ${totalNumRecs} Results for “${searchQuery}”`
    })
  ),
  withProps(({ options }) => {
    const { value } = options.find(({ selected }) => selected) || {}

    return {
      initialValues: {
        [SORT_BY_INPUT_NAME]: value
      },
      viewModel: {
        sort: {
          inputType: inputTypes.SELECT_DROPDOWN_INPUT,
          label: SORT_BY_INPUT_LABEL,
          name: SORT_BY_INPUT_NAME,
          options,
          isSearchable: false
        }
      }
    }
  }),
  withHandlers({
    handleFilterChange: ({ options, applySort }) => ({ value } = {}) => {
      applySort({ navigationState: value })
    }
  }),
  reduxForm({ form: FORM_NAME })
)(ResultsPageListHeader)
